import {
    AppBar, Toolbar, Typography, IconButton,
} from '@mui/material';
import MainMenu from './Menu'
import { useTournamentContext } from './context';
import RefreshIcon from '@mui/icons-material/Refresh';

function AppToolbar() {
    const { tournament } = useTournamentContext();

    return (
        <AppBar position="static" color="info">
            <Toolbar>
                <MainMenu />

                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>{tournament?.name}</Typography>

                <IconButton onClick={() => window.location.reload()} style={{color: 'white'}}>
                    <RefreshIcon />
                </IconButton>
            </Toolbar>
        </AppBar>
    );
}

export default AppToolbar;
